export default __webpack_public_path__ + "static/media/mup-transparent.39296262.gif";